export function clamp(value, min, max) {
  return Math.min(Math.max(value, min), max);
}

export function getMinMax(values) {
  if (!values.length) {
    return { min: 0, max: 0 };
  }

  let min = values[0];
  let max = values[0];

  for (let i = 1; i < values.length; i += 1) {
    const current = values[i];
    if (current < min) min = current;
    if (current > max) max = current;
  }

  return { min, max };
}

export function scaleLinear(value, domainMin, domainMax, rangeMin, rangeMax) {
  if (domainMax === domainMin) {
    return (rangeMin + rangeMax) / 2;
  }
  const ratio = (value - domainMin) / (domainMax - domainMin);
  return rangeMin + ratio * (rangeMax - rangeMin);
}

export function createLinePath(points) {
  if (!points.length) return "";

  const [first, ...rest] = points;
  const start = `M ${first.x} ${first.y}`;
  const segments = rest.map((point) => `L ${point.x} ${point.y}`).join(" ");
  return `${start} ${segments}`.trim();
}

export function createAreaPath(points, baselineY) {
  if (!points.length) return "";
  const linePath = createLinePath(points);
  const last = points[points.length - 1];
  const first = points[0];
  return `${linePath} L ${last.x} ${baselineY} L ${first.x} ${baselineY} Z`;
}

export function padDomain(min, max, paddingRatio = 0.1) {
  if (min === max) {
    const offset = min === 0 ? 1 : Math.abs(min * paddingRatio);
    return { min: min - offset, max: max + offset };
  }
  const range = max - min;
  const padding = range * paddingRatio;
  return { min: min - padding, max: max + padding };
}
